export default __webpack_public_path__ + "static/media/baby-17.9d8a9ea0.svg";